import { usePermissionsValidator } from 'b2b-apps/shop/context/hooks';

export type UseCheckPermissionsReturnType = boolean;

export const useCheckPermissions = (
  requiredPermissions: string[],
): UseCheckPermissionsReturnType => {
  const permissionsValidator = usePermissionsValidator();

  return permissionsValidator(requiredPermissions);
};
